import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent } from "vue";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
import { isShowApi } from "@/utils/isAllApi";
import Swiper from "@/baseui/swiper/swiper.vue";
import CmdPlayList from "./cpns/cmdPlayList.vue";
import AlonePlay from "./cpns/alonePlay.vue";
import NewMusic from "./cpns/newMusic.vue";
import CmdMv from "./cpns/cmdMv.vue";
import DjprogramVue from "./cpns/Djprogram.vue";
import Loading from "@/baseui/loading/loading.vue";
export default defineComponent({
  name: "Home",
  setup: function setup() {
    var store = useStore();
    var state = useState("Home", ["swiperList", "commendList", "aloneList", "newMusicList", "commendMvList", "djprogramList"]);
    /* vuex获取接口数据 */

    store.dispatch("Home/getSwiperList");
    store.dispatch("Home/getCommendList");
    store.dispatch("Home/getAloneList");
    store.dispatch("Home/getnewMusicList");
    store.dispatch("Home/getCmdMvList");
    store.dispatch("Home/getDjprogramList"); //当前页面所有请求完毕则显示页面内容

    var isShow = isShowApi(state);
    return _objectSpread(_objectSpread({}, state), {}, {
      isShow: isShow
    });
  },
  components: {
    Swiper: Swiper,
    CmdPlayList: CmdPlayList,
    AlonePlay: AlonePlay,
    NewMusic: NewMusic,
    CmdMv: CmdMv,
    DjprogramVue: DjprogramVue,
    Loading: Loading
  }
});